module.exports = __webpack_public_path__ + "static/media/error-page-illustration.71f7c2b3.svg";